module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-main-modal-logist/home-main-modal-logist.component.sass
// module id = ./src/app/modules/home/components/home-main-modal-logist/home-main-modal-logist.component.sass
// module chunks = main